import { render } from "./_BoardProfiles.vue?vue&type=template&id=48f4f17f&lang=en"
import script from "./_BoardProfiles.vue?vue&type=script&lang=js"
export * from "./_BoardProfiles.vue?vue&type=script&lang=js"

import "./_BoardProfiles.vue?vue&type=style&index=0&id=48f4f17f&lang=scss"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__